import React, { Component } from "react";
import "./Loading.css";

class Loading extends Component {
  render() {
    return (
      <div className="LoadingContainer">
        <div className="Loading" />
      </div>
    );
  }
}

export default Loading;
